
import ButtonComponent from '../shared/button/button.component';
import { ChannelType } from '../../models/channels/channels.model';
import { ProviderService } from '../../services/channels/ChannelProviderService';
import { ChannelService } from '../../services/channels/ChannelAcountService';
import { CancelIcon } from '../../icon';
import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { ChannelUserModel, mapToChannelUser } from '../../models/users.model';

const FB = (window as any).FB;

interface IProps {
    Show: boolean;
    CloseChannel: (refresh?: boolean) => void;
    IsMobileDevice?: boolean;
    ChannelType: number;
}

const FacebookChannelViewComponent = (props: IProps) => {

    const handleClose = () => {
        props.CloseChannel();
    };

    const openScope = () => {
        ProviderService.getAppData(props.ChannelType).then(res => {
            const closeChannel = props.CloseChannel;
            const { appid, scope } = res.data;
            FB.init({
                appId: appid,
                autoLogAppEvents: true,
                xfbml: true,
                version: "v21.0",
            });

            FB.login(function (response) {

                const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;
                let data = {
                    tenant_user_id: user?.ID,
                    channel_user_id: response.authResponse?.userID,
                    token: response.authResponse?.accessToken
                }
                ChannelService.createChannelAccount(user.OrganizationID, props.ChannelType, data).then(res => {
                    closeChannel(true)
                }).catch(err => {

                })
            }, { scope });
            return
        }).catch(err => { })
    }

    return (
        <div>
            <Dialog
                maxWidth="sm"
                onClose={() => handleClose()}
                aria-labelledby="responsive-dialog-title"
                open={props.Show}
                BackdropProps={{
                    style: { backgroundColor: "transparent" },
                }}
                className={"dialogue-shadow"}
            >
                <DialogTitle className="pb-0" >
                    <div className={`h2-semibold color-display-title d-flex mx-auto`} id="">
                        <div className='mx-auto'> {"Add Messenger"}</div>
                        <Tooltip title="Close" placement="bottom">
                            <span className=" ">
                                <CancelIcon className={"c-pointer"} onClick={handleClose} />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent className={`t-align-center ${props.IsMobileDevice ? "" : "w-50"}  color-channel-name-font h5-regular px-5`}>
                    {props.ChannelType === ChannelType.INSTAGRAM ?
                        <>
                            Continue with Instagram to link a page to a Falkon Connect Inbox. Before proceeding, make sure that you are an admin of the page you plan to add. If you are not, a current page admin can either set up the integration or <a href='https://www.facebook.com/help/187316341316631' target="_blank" rel="noreferrer" className='t-decoration-underline color-channel-text-link'>add you as page admin.</a>
                        </>
                        :
                        props.ChannelType === ChannelType.FACEBOOK ?
                            <>
                                Continue with Facebook to link a page to a Falkon chat inbox. Before proceeding, make sure that you are an admin of the page you plan to add. If you are not, a current page admin can either set up the integration or <a href='https://www.facebook.com/help/187316341316631' target="_blank" rel="noreferrer" className='t-decoration-underline color-channel-text-link'>add you as page admin.</a>
                            </>
                            :
                            <>
                                Continue with Whatsapp to link a page to a Falkon chat inbox. Before proceeding, make sure that you are an admin of the page you plan to add. If you are not, a current page admin can either set up the integration or <a href='https://www.facebook.com/help/187316341316631' target="_blank" rel="noreferrer" className='t-decoration-underline color-channel-text-link'>add you as page admin.</a>
                            </>
                    }</DialogContent>

                <DialogActions className="py-2 mr-2">
                    <div className='mx-auto'>
                        <ButtonComponent
                            buttonProps={{ autoFocus: true }} OnClick={() => {
                                //get facebook login scope
                                openScope()
                            }}
                            ButtonLabel={props.ChannelType === ChannelType.INSTAGRAM ? "Continue with Instagram" : "Continue with facebook"}
                            ClassName={"c-pointer t-align-center br-5"}
                            Variant={"primary-btn-small"}
                        />
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default FacebookChannelViewComponent;
